import * as React from 'react';
import * as styles from './InlineLink.css';

type TInlineLinkBaseProps = Omit<React.ComponentPropsWithoutRef<'a'>, 'style' | 'className'>;

export const InlineLink = React.forwardRef<HTMLAnchorElement, TInlineLinkBaseProps>((props, ref) => {
  // eslint-disable-next-line react/jsx-no-target-blank
  return <a className={styles['link']} ref={ref} {...props} />;
});

InlineLink.displayName = 'InlineLink';
